export function phoneNumberValidator(
  value: string | null | undefined
): boolean {
  if (value) return /^(9)\d{8}$/.test(value);
  return true;
}

export function timeValidator(value: string | null | undefined): boolean {
  try {
    const date = new Date(value!);
    const timeOnly = date.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/.test(timeOnly);
  } catch (e) {
    return false;
  }
}

export function fileRequiredValidate(value: any): boolean {
  if (!value) return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (Array.isArray(value))
    return value.every((file) => {
      return file.status ? file?.status === "done" : file.url;
    });
  return true;
}

export function fileOptionalValidate(value: any): boolean {
  if (!value) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (Array.isArray(value))
    return value.every((file) =>
      file.status ? file?.status === "done" : file.url
    );
  return true;
}

export function positiveNumberValidator(
  value: string | null | undefined
): boolean {
  if (
    value !== null &&
    value !== undefined &&
    typeof value === "string" &&
    value.trim().length > 0 &&
    !isNaN(Number(value))
  )
    return Number(value) > 0;
  return true;
}
